var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6 16C3.7 20.6 2 26.1 2 32h60c0-5.9-1.7-11.4-4.6-16H6.6z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4 48c2.9-4.6 4.6-10.1 4.6-16H2c0 5.9 1.7 11.4 4.6 16h50.8z",
    fill: "#699635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 48c3.9 6.2 10.1 10.9 17.4 12.9h16c7.3-2 13.4-6.7 17.4-12.9H6.6z",
    fill: "#ffe62e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 3.1H24C16.7 5.1 10.6 9.8 6.6 16h50.7C53.4 9.8 47.3 5.1 40 3.1z",
    fill: "#2a5f9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 3.1C37.5 2.4 34.8 2 32 2s-5.5.4-8 1.1v57.8c2.5.7 5.2 1.1 8 1.1s5.5-.4 8-1.1V3.1",
    fill: "#f42f4c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe62e",
    d: "M18 11.6l1.9 1.4l-.7-2.3L21 9.3h-2.3L18 7l-.7 2.3H15l1.8 1.4l-.7 2.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXaf);
export default __webpack_public_path__ + "static/media/xaf.e1c5297db26ac7c3a63794fd2700a9b4.svg";
export { ForwardRef as ReactComponent };